// This file is AUTOGENERATED, do not edit it manually!!!

export const projectFinancials = {
    ActualBudgetProfitability: 'Tatsächliche Budget-Rentabilität',
    ActualCost: 'Tatsächliche Kosten',
    ActualExpensesListTitle: 'Tatsächlich',
    ActualHours: 'Tatsächlich aufgewendete Stunden',
    AddBudgetLabel: 'Budget für dieses Projekt hinzufügen',
    Amount: 'Betrag',
    ApproveTooltip: 'Überträgt geplante Ausgaben zu den tatsächlichen',
    batch_billed_text: 'Als abgerechnet markieren',
    Billable: 'Berechnungsfähig',
    Billed: 'Abgerechnet',
    BillingHelp: 'Im Rechnungsabschnitt können Sie den Rechnungstyp für das Projekt auswählen und eine Rate wie Stunden- oder Pauschaltarif für eine Rechnung einstellen.',
    BillingTypeLabel: 'Berechnen anhand von ',
    BillingUtilization: 'Kostenanwendung',
    BudgetedCost: 'Gesamtprojektbudget',
    BudgetHelp: 'In diesem Abschnitt können Sie das Gesamtbudget des Projektes mit allen Aktivitäten einsehen und ein Budgetlevel einstellen.',
    CancelTooltip: 'Abbrechen',
    CPI: 'CPI',
    CustomerHourlyRateLabel: 'Kundenstundensatz',
    Date: 'Datum',
    DeletePaymentConfirmation: 'Wollen Sie wirklich diesen Eintrag löschen?',
    DeleteTooltip: 'Löschen',
    Description: 'Beschreibung',
    EstimatedBudgetProfitability: 'Erwartete Budget-Rentabilität',
    EstimatedCostVariance: 'Geschätzte Kostenabweichung',
    EstimatedExpenses: 'Geschätzte Kosten',
    EstimatedHours: 'Geschätzter Stundenaufwand',
    ExpectedRevenue: 'Erwarteter Projektumsatz',
    InternalEstimatedCost: 'Erwartete Kosten',
    NoActualExpenses: 'Es gibt keine Ausgaben.',
    None: 'Keine',
    NoneCurrency: 'Währung wählen',
    NoPayments: 'Es gibt keine Zahlungen.',
    NoPlannedExpenses: 'Es gibt keine geplanten Ausgaben.',
    NotBillable: 'Nicht berechnungsfähig',
    NotBillableLabel: 'Nicht berechnungsfähig',
    NotBilled: 'Nicht abgerechnet',
    PaymentDescriptionWatermark: 'Beschreibung…',
    PercentageBilled: 'Anteil abgerechnet',
    PercentageProjectBilled: 'Anteil abgerechnet',
    PlannedExpenses: 'Geplante Ausgaben',
    PlannedExpensesListTitle: 'Geplant',
    ProjectBilling: 'Projektkosten',
    ProjectBillingUtilization: 'Kostenanwendung',
    ProjectBudget: 'Projektbudget',
    ProjectCost: 'Interne Kosten des Projekts',
    ProjectCostVariance: 'Kostenspielraum des Projekts',
    ProjectEarnedValue: 'Ertragswert des Projekts',
    ProjectEarnedValueInfo: 'Projektgesundheit',
    ProjectExpectedRevenue: 'Erwarteter Projektumsatz',
    ProjectFixedCostLabel: 'Projekt-Fixkosten',
    ProjectHourlyRateLabel: 'Projekt-Stundensatz',
    ProjectPayments: 'Zahlungen des Projekts',
    ProjectPlannedExpenses: 'Geplante Ausgaben des Projekts',
    ProjectPlannedExpensesInfo: 'Geplante Ausgaben für ein spezielles Projekt und geplante Ausgaben aus entsprechenden Aktivitäten',
    ProjectProfit: 'Projektprofit',
    ProjectProfitability: 'Projektertragswert',
    ProjectProfitabilityInfo: 'Anteil des erstellten Projektwertes',
    ProjectTimeUsage: 'Nutzzeit des Projekts',
    ProjectTimeUsageInfo: 'Anzeige, wie viel der Zeit bereits abgelaufen ist, tatsächlich als Prozent der geschätzten Stunden',
    ProjectWorkInProgress: 'Laufende Arbeit (WIP) des Projekts',
    ResourceHourlyRateLabel: 'Ressourcen-Stundensatz',
    ShowAll: 'ALLE ANZEIGEN',
    ShowFull: 'VOLLSTÄNDIG ANZEIGEN',
    SPI: 'SPI',
    TaskRateLabel: 'Aktivitätsrate',
    TimeUsage: 'Zeitnutzung',
    TitleText: 'Finanzen',
    TotalBilled: 'Gesamtberechnung',
    TotalProjectBudget: 'Gesamtbudget für das Projekt',
    TotalProjectPayments: 'Gesamte Projektzahlungen',
    TotalProjectPaymentsInfo: 'Zusammenfassung aller Zahlungen von allen Kunden',
    Validation_DateMandatory: 'Datum erforderlich.',
    Validation_InvalidAmount: 'Menge muss positiv sein.',
    Validation_InvalidDate: 'Datum muss Format \'{0}\' aufweisen.',
    Validation_Range: 'Wert ist nicht im erwarteten Rahmen.',
    WorkInProgress: 'Laufende Arbeit (WIP)',
};
